import { useEffect } from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { isLocal } from "./currentRunningEnvironment";

const initDatadogSDK = () => {
  const internalContext = datadogRum.getInternalContext();

  if (internalContext || isLocal) {
    return;
  }

  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE_NAME,
    env: REACT_APP_ENV,
    version: REACT_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [REACT_APP_API_BASE_URL_NEW, REACT_APP_IDENTITY_SERVER_BASE_URL],
  });

  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
};

export const startTrackingLoggedInUserForDatadog = userData => {
  if (!userData?.fullName || !userData?.email || !userData?.id) {
    console.warn("Unable to identify user for Datadog RUM. Session will remain anonymous.");

    return;
  }

  datadogRum.setUser({
    name: userData.fullName,
    email: userData.email,
    id: userData.id,
  });
};

export const stopTrackingLoggedInUserForDatadog = () => {
  datadogRum.clearUser();
};

export const useDatadog = () => {
  useEffect(() => {
    initDatadogSDK();
  }, []);
};
